import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null
};

export const host = createSlice({
  name: "shop",
  initialState,
  reducers: {
    updateHost(state, action) {
      state.data = action.payload;
    }
  }
});

export const { updateHost } = host.actions;

export default host.reducer;